import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../../stores/auth-store';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const user = useAuthStore((s) => s.user);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Phase 9 follow-up — customer-portal users should NEVER reach the
  // admin TMS shell. If a legacy JWT from before the server-side
  // /auth/login rejection landed in localStorage, bounce them here.
  // The dedicated `/customer-portal` route has its own auth state in
  // sessionStorage and is exempt (not wrapped in ProtectedRoute in
  // App.tsx — it's a public-shell page that manages its own session).
  if (user?.role === 'customer') {
    return <Navigate to="/customer-portal" replace />;
  }

  return <>{children}</>;
}
